"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminWorkflowStatus = exports.AdminWorkflowStatusArray = exports.PARTNER_MEMBERSHIP_PREFIX = exports.SHORE_BASED_MEMBERSHIP_SLUG = exports.SHORE_BASED_MEMBER_RATE = exports.FULL_MEMBER_SLUG = exports.FULL_MEMBER_RATE = exports.BASIC_MEMBERSHIP_SLUG = exports.BASIC_MEMBERSHIP_RATE = exports.HONORARY_MEMBER_RATE = exports.NON_MEMBER_RATE = exports.SSTRequestStatusMap = exports.SSTRequestStatus = exports.DateFormatFull = exports.DateFormatDay = exports.DateFormatMonthDay = exports.CertificateDocumentStatuses = exports.FindConstById = exports.FindConstByTitle = exports.FindConstTitle = exports.UserDocumentStatusMap = exports.UserDocumentStatus = exports.DocumentStatus = exports.isExpiryRequiredForDocument = exports.PersonalDocumentName = exports.DocumentNames = exports.WhyJoinPYA = exports.titles = exports.SignatoryPositions = exports.YachtPositions = exports.YachtType = exports.TypeOfBusiness = exports.MembersDashboardFilters = void 0;
var MembersDashboardFilters;
(function (MembersDashboardFilters) {
    MembersDashboardFilters["ALL_MEMBERS"] = "All Members";
    MembersDashboardFilters["JUST_JOINED"] = "Just Joined";
    MembersDashboardFilters["PENDING"] = "Pending";
    MembersDashboardFilters["RECENT_LOGIN"] = "Recent Login";
    MembersDashboardFilters["EXPIRE_THIS_MONTH"] = "Expire this month";
    MembersDashboardFilters["EXPIRE_LAST_MONTH"] = "Expired last month";
})(MembersDashboardFilters || (exports.MembersDashboardFilters = MembersDashboardFilters = {}));
// TODO These 2 arrays will need to be added somewhere for PYA to admin.
exports.TypeOfBusiness = [
    { title: 'Crew Agency', id: '66226b172f63c089150b55c2' },
    { title: 'Yacht Management', id: '66226b172f63c089150b55c3' },
    { title: 'Marina / Port', id: '66226b172f63c089150b55c4' },
    { title: 'Training Provider', id: '66226b172f63c089150b55c5' },
    { title: 'Services to yachts or crew', id: '66226b172f63c089150b55c6' },
    { title: 'Yachting association', id: '66226b172f63c089150b55c7' },
    { title: 'Brokerage / Charter', id: '66226b172f63c089150b55c8' },
    { title: 'Yacht media', id: '66226b172f63c089150b55c9' },
    { title: 'Other  ', id: '66226b172f63c089150b55ca' },
];
exports.YachtType = [
    { id: 'SY', title: 'Sail Yacht' },
    { id: 'MY', title: 'Motor Yacht' },
];
exports.YachtPositions = [
    { title: 'Chief Officer', id: '6620f05cb1c189cf4a04b2d6' },
    { title: 'Captain', id: '6620f05cb1c189cf4a04b2d7' },
    { title: 'Captain / Deck', id: '6620f05cb1c189cf4a04b2d8' },
    { title: 'Captain / Engineer', id: '6620f05cb1c189cf4a04b2d9' },
    { title: 'Deck crew', id: '6620f05cb1c189cf4a04b2da' },
    { title: 'Engineer', id: '6620f05cb1c189cf4a04b2db' },
    { title: 'Deck / Engineer', id: '6620f05cb1c189cf4a04b2dc' },
    { title: 'Interior', id: '6620f05cb1c189cf4a04b2dd' },
    { title: 'Deck / Interior', id: '6620f05cb1c189cf4a04b2de' },
    { title: 'Chef', id: '6620f05cb1c189cf4a04b2df' },
    { title: 'Chef / Interior', id: '6620f05cb1c189cf4a04b2e0' },
    { title: 'Other', id: '6620f05cb1c189cf4a04b2e1' },
    // From the Signatories, the ones with 500+ repetitions
    { title: 'Master', id: '679ba209a0acae8969488384' },
    { title: 'Deckhand', id: '679ba5221683f68e26f3f74d' },
    { title: 'Chief Mate', id: '679ba53775645506e557cabb' },
    { title: 'Bosun', id: '679ba55c90916f3e9053673f' },
    { title: 'Chief Engineer', id: '679ba583953a0608683a1792' },
    { title: '2nd Engineer', id: '679ba727516e150322b87647' },
    { title: 'OOW', id: '679ba72c624102feedfcbf23' },
];
exports.SignatoryPositions = [
    { title: 'CEO', id: '665a7f3be8c4d2a9f6b13e75' },
    { title: 'Chief Engineer', id: '663c89a7f8d4e2b1c5a9f032' },
    { title: 'Chief Instructor', id: '6641d7f2e9c8b3a4d7f21e56' },
    { title: 'Chief Officer', id: '6658a3c4b9e7d1f8c2a5b894' },
    { title: 'Crew Coordinator', id: '667f21b8d3c9e4a7f5b12c67' },
    { title: 'Crew Director', id: '6693e8f1a6d2c7b9e3f45a81' },
    { title: 'Director', id: '66a84c2f7b5e1d8a4c9f6e23' },
    { title: 'DPA', id: '66bd71e5c8f3a9d2b6e18f47' },
    { title: 'Fleet Manager', id: '66d29a83f4e6b1c7a9d52e69' },
    { title: 'Fleet Master', id: '66e7c3f9a1d8e5b2c6f94a83' },
    { title: 'Manager', id: '66fcb6d4e2c9f7a3d8b51e27' },
    { title: 'Marine Superintendent', id: '671185a8f3e6c2d9b7a48f65' },
    { title: 'Master', id: '6726d9c7a4f1e8b5c2d96e41' },
    { title: 'Master / Chief Engineer', id: '673b4ef2b8d5c1a6e9f37c84' },
    { title: 'Master / Fleet Captain', id: '6750a2d6c9f4e7b3a8d61f28' },
    { title: 'Master / Manager', id: '676597fb4e1c8d5a2f9b46e7' },
    { title: 'Master / Owner', id: '677ae3c8f7d2b9a5c1e84f63' },
    { title: "Master / Owner's Representative", id: '678f16a4d8c5e2f9b6a37e49' },
    { title: 'Master/Chief Officer', id: '67a459f1b3e6c8d4a7f92b85' },
    { title: 'Operations Director', id: '67b9cd2e5f8a1d6c9b4e7a21' },
    { title: 'Owner', id: '67ce81b7a2f5e9c6d3b86f47' },
    { title: "Owner's representative", id: '67e3f4da6c9b2e8a5d1f73c9' },
    { title: 'President', id: '67f867e9d4a7c1f8b5e29a64' },
    { title: 'Purser', id: '680dab3c8f6e2d9a7c4b1f86' },
    { title: 'Relief Master', id: '68221e7fb5c8a4d6e9f37b28' },
    { title: 'Second Engineer', id: '683792d4a1f6c9e5b8d24f67' },
    { title: 'Shipyard Director', id: '684c65a8e3d7b2f9c6a58e43' },
    { title: 'Technical Superintendent', id: '6861d9fb7a4c8e6d2f9b37a5' },
    { title: 'Training Manager', id: '68764c2ea8f5d1c9b6e74f81' },
    { title: 'Yacht Manager', id: '688b8f61d3a6e9c7f4b52e29' },
];
// These 2 should come from the DB
exports.titles = [
    { id: '66226c072f63c089150b55cb', title: 'Mr' },
    { id: '66226c072f63c089150b55cc', title: 'Mrs' },
    { id: '66226c072f63c089150b55cd', title: 'Miss' },
    { id: '66226c072f63c089150b55ce', title: 'Ms' },
    { id: '66226c072f63c089150b55cf', title: 'Dr' },
    { id: '66226c072f63c089150b55d0', title: 'Prof' },
    { id: '66226c072f63c089150b55d1', title: 'Rev' },
    { id: '66226c072f63c089150b55d2', title: 'Hon' },
    { id: '66226c072f63c089150b55d3', title: 'Captain' },
    { id: '66226c072f63c089150b55d4', title: 'Sgt' },
    { id: '66226c072f63c089150b55d5', title: 'N/S' },
];
exports.WhyJoinPYA = [
    { id: '66226c3b2f63c089150b55d5', title: 'Sea Service verification' },
    { id: '66226c3b2f63c089150b55d6', title: 'Advice on NOE/Revalidation application' },
    { id: '66226c3b2f63c089150b55d7', title: 'Advice on contracts and/or related matters' },
    { id: '66226c3b2f63c089150b55d8', title: 'To support the PYA and industry' },
    // This one makes NO sense.
    { id: '66226c3b2f63c089150b55d9', title: 'Other - please specify' },
    // What's going on with this ones...
];
// This was like so due to the lack of consistency on the migration.
// Whenever a PersonalDocument needs to be hidden, just set the disabled on true.
var DocumentNames;
(function (DocumentNames) {
    DocumentNames["PASSPORT"] = "Passport";
    DocumentNames["ENG1_OR_MEDICAL"] = "ENG1 or Medical";
    DocumentNames["LOG_BOOK"] = "Log book";
    DocumentNames["SEAMAN_BOOK"] = "Seaman Book";
    DocumentNames["CV"] = "CV";
    DocumentNames["HISTORICAL_SRB"] = "Historical PYA Service Record";
    DocumentNames["SRB"] = "PYA Service Record";
    DocumentNames["VERIFICATION"] = "Verification";
    DocumentNames["CERTIFICATE"] = "Certificate";
    DocumentNames["ISSUER_CHECK"] = "Issuer Check";
})(DocumentNames || (exports.DocumentNames = DocumentNames = {}));
exports.PersonalDocumentName = [
    { id: '66545f47ea632560cc0e58f7', title: DocumentNames.PASSPORT, expiryRequired: true },
    { id: '66545f47ea632560cc0e58f8', title: DocumentNames.ENG1_OR_MEDICAL, expiryRequired: true },
    { id: '66545f47ea632560cc0e58f9', title: DocumentNames.LOG_BOOK, expiryRequired: false },
    { id: '66545f47ea632560cc0e58fa', title: DocumentNames.SEAMAN_BOOK, expiryRequired: false },
    { id: '66545f47ea632560cc0e58fb', title: DocumentNames.CV, expiryRequired: false },
    // These 3 ammount for almost 99% of failures, I'm adding them
    { id: '668571a5e78679229ae7e70f', title: DocumentNames.SRB, expiryRequired: false },
    { id: '66856b67c3ed6e07e95958f7', title: DocumentNames.VERIFICATION, disabled: true, expiryRequired: true },
    //Removed per PYA request
    //{ id: '66856c48f6c6d44d51b79b02', title: DocumentNames.CERTIFICATE, expiryRequired: true },
    //{ id: '66856b827aca6c8f6f0813a2', title: DocumentNames.ISSUER_CHECK, expiryRequired: true },
    //{ id: '66545f47ea632560cc0e58fc', title: DocumentNames.HISTORICAL_SRB, expiryRequired: false },
];
var isExpiryRequiredForDocument = function (documentId) {
    var _a;
    var doc = exports.PersonalDocumentName.find(function (d) { return d.id === documentId; });
    return (_a = doc === null || doc === void 0 ? void 0 : doc.expiryRequired) !== null && _a !== void 0 ? _a : true; // Default to true for safety
};
exports.isExpiryRequiredForDocument = isExpiryRequiredForDocument;
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["UPLOADED"] = "Uploaded";
    DocumentStatus["UNDER_REVIEW"] = "Under Review";
    DocumentStatus["SIGHTED"] = "Sighted";
    DocumentStatus["VERIFIED"] = "Verified";
    DocumentStatus["DECLINED"] = "Declined";
    DocumentStatus["ACKNOWLEDGED"] = "Acknowledged";
    DocumentStatus["NOT_VERIFIED"] = "Not verified";
    // Meant for NCap
    DocumentStatus["APPROVED"] = "Approved";
    DocumentStatus["VALIDATED"] = "Validated";
    DocumentStatus["EXCLUDED"] = "Excluded";
    DocumentStatus["DELETED"] = "Deleted";
})(DocumentStatus || (exports.DocumentStatus = DocumentStatus = {}));
exports.UserDocumentStatus = [
    {
        title: DocumentStatus.UPLOADED,
        id: '5ecb01503e2b6e1b8d6a8f1b',
    },
    {
        title: DocumentStatus.UNDER_REVIEW,
        id: '665f2fcb5f7ef837edf12408',
    },
    {
        title: DocumentStatus.SIGHTED,
        id: '5ecb01503e2b6e1b8d6a8f1c',
    },
    {
        title: DocumentStatus.VERIFIED,
        id: '5ecb01503e2b6e1b8d6a8f1d',
    },
    {
        title: DocumentStatus.DECLINED,
        id: '5ecb01503e2b6e1b8d6a8f1e',
    },
    {
        title: DocumentStatus.ACKNOWLEDGED,
        id: '67a8f3b24e5c9d1f2a3b4c6d',
    },
    // This one is excluding almost 1k testimonials.
    {
        title: DocumentStatus.NOT_VERIFIED,
        id: '668f7fb2bc32ce665ed161ee',
    },
    {
        title: DocumentStatus.APPROVED,
        id: '668ed35c9e69c0d8c8f7caba',
    },
    {
        title: DocumentStatus.VALIDATED,
        id: '678a19f8549faedd0d444dc2',
    },
    // PMM-614
    {
        title: DocumentStatus.EXCLUDED, // New status
        id: '6862aee050992271d967c4c5',
    },
    {
        title: DocumentStatus.DELETED, // Soft delete status
        id: '67a4ce7f2d0599519228590e',
    },
];
exports.UserDocumentStatusMap = {
    Uploaded: '5ecb01503e2b6e1b8d6a8f1b',
    'Not verified': '668f7fb2bc32ce665ed161ee',
    'Under Review': '665f2fcb5f7ef837edf12408',
    Approved: '668ed35c9e69c0d8c8f7caba',
    Declined: '5ecb01503e2b6e1b8d6a8f1e',
    Acknowledged: '67a8f3b24e5c9d1f2a3b4c6d',
    Sighted: '5ecb01503e2b6e1b8d6a8f1c',
    Verified: '5ecb01503e2b6e1b8d6a8f1d',
    Validated: '678a19f8549faedd0d444dc2',
    Excluded: '6862aee050992271d967c4c5',
    Deleted: '67a4ce7f2d0599519228590e',
};
var FindConstTitle = function (collection, id) {
    var _a;
    return (_a = collection.find(function (udt) { return udt.id === id; })) === null || _a === void 0 ? void 0 : _a.title;
};
exports.FindConstTitle = FindConstTitle;
var FindConstByTitle = function (collection, title) {
    if (!title)
        return undefined;
    return collection.find(function (udt) { return udt.title.toLowerCase() === title.toLowerCase(); });
};
exports.FindConstByTitle = FindConstByTitle;
var FindConstById = function (collection, id) {
    return collection.find(function (udt) { return udt.id === id; });
};
exports.FindConstById = FindConstById;
/** Statuses relevant for certificate/passport manual editing (excludes SST-only and system-managed) */
exports.CertificateDocumentStatuses = exports.UserDocumentStatus.filter(function (s) {
    return [
        DocumentStatus.UPLOADED,
        DocumentStatus.UNDER_REVIEW,
        DocumentStatus.SIGHTED,
        DocumentStatus.VERIFIED,
        DocumentStatus.DECLINED,
        DocumentStatus.ACKNOWLEDGED,
    ].includes(s.title);
});
exports.DateFormatMonthDay = 'DD/MM';
exports.DateFormatDay = 'DD/MM/YYYY';
exports.DateFormatFull = 'DD/MM/YYYY HH:mm';
exports.SSTRequestStatus = __spreadArray(__spreadArray([], exports.UserDocumentStatus, true), [
    {
        title: 'Draft', // New status
        id: '679ccccafac6c0d4ca104b91',
    },
    {
        title: 'Deleted', // New status
        id: '67a4ce7f2d0599519228590e',
    },
], false);
exports.SSTRequestStatusMap = __assign(__assign({}, exports.UserDocumentStatusMap), { Draft: '679ccccafac6c0d4ca104b91', Deleted: '67a4ce7f2d0599519228590e', Excluded: '6862aee050992271d967c4c5' });
exports.NON_MEMBER_RATE = 'Non member';
exports.HONORARY_MEMBER_RATE = 'Honorary Member';
/** @deprecated Prefer BASIC_MEMBERSHIP_SLUG for logic; display name may be renamed in admin */
exports.BASIC_MEMBERSHIP_RATE = 'Basic Membership';
exports.BASIC_MEMBERSHIP_SLUG = 'new-to-yachting';
exports.FULL_MEMBER_RATE = 'Full Member';
exports.FULL_MEMBER_SLUG = 'full-member';
exports.SHORE_BASED_MEMBER_RATE = 'Shore Based member';
exports.SHORE_BASED_MEMBERSHIP_SLUG = 'shore-based';
// Partner membership types have slugs starting with this prefix
exports.PARTNER_MEMBERSHIP_PREFIX = 'partner-';
// Admin workflow status for SST Request management
exports.AdminWorkflowStatusArray = ['Pending', 'Doing', 'Hold'];
exports.AdminWorkflowStatus = [
    { id: 'Pending', title: 'Pending' },
    { id: 'Doing', title: 'In Progress' },
    { id: 'Hold', title: 'On Hold' },
];
//# sourceMappingURL=const.js.map